/** @format */

export const CELL_HEIGHT = 32;
export const HEAD_HEIGHT = 72;
export const ARROW_CELL_WIDTH = 31;
export const CHECKBOX_CELL_WIDTH = 47;
export const CHECKBOX_OFFSET_X = 6;
export const CHECKBOX_OFFSET_Y = 20;
export const MIN_BODY_HEIGHT = 20;
export const WINDOW_PADDING = 96;
export const DEFAULT_TABLE_HEIGHT = 500;
// Минимальная ширина колонки при ресайзе пользователем, px.
export const MIN_COLUMN_WIDTH = 80;

// Атрибут, по которому ручка ресайза находит свой <col>: пишется в Table.tsx, читается в
// ColumnResizer. Держим в одном месте, иначе переименование в одном файле молча ломает драг.
export const COLUMN_ID_ATTRIBUTE = 'data-column-id';
